export class DaysOfWeek {
    static days = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/DaysOfWeek.ts